import { OrganSupportApi, type OrganSupportDTO } from '@/generated'
import { globalApiConfig } from '@/services/telehealthApi/APIConfig'

export class OrganSupportService {
  static readonly organSupportApi = new OrganSupportApi(globalApiConfig)

  static async getOrganSupport(
    caseId: string,
    shareCode: string | undefined
  ): Promise<OrganSupportDTO> {
    return (await OrganSupportService.organSupportApi.getOrganSupport(caseId, shareCode)).data
  }
}
